module.exports = __webpack_public_path__ + "images/category_lp/pc/media4_9e97b1e176b2562b4b76e74794d17ccf.jpg";